import { SerializableObject } from './serializable-object';


export class SignUpViewModel extends SerializableObject {
  public email: string;
  public fullName: string;
  public identificationNumber: string;
  public language: string;
  public password: string;
  public phoneNumber: string;
}
